export default __webpack_public_path__ + "static/media/avatar.ac2d02c0.svg";